import { Table } from 'antd'
import { TableProps } from 'antd/lib/table'
import React from 'react'
import styled from 'styled-components'

const StyledTable: any = styled(Table)<{ simpleMode?: boolean }>`
  &.ant-table-wrapper {
    .ant-table {
      background: ${p => p.theme.table.bg};
      & table {
        border-spacing: 0 ${p => p.theme.table.borderSpacing}px;
      }
    }

    &.pagination--none .ant-table-pagination {
      display: none;
    }
    .ant-pagination-simple {
      .ant-pagination-simple-pager {
        color: ${p => p.theme.pagination.simpleModeColor};
        input {
          border: 1px solid ${p => p.theme.pagination.simpleModeColor};
          background-color: transparent;
        }
      }
      .ant-pagination-prev .ant-pagination-item-link,
      .ant-pagination-next .ant-pagination-item-link {
        color: ${p => p.theme.pagination.simpleModeColor};
      }
    }

    .ant-pagination-prev .ant-pagination-item-link,
    .ant-pagination-next .ant-pagination-item-link {
      border-color: ${p => p.theme.pagination.borderColor};
      border-radius: 6px;
      color: ${p => p.theme.pagination.color};
      background: ${p => p.theme.pagination.bg};
    }

    .ant-pagination-item {
      border-color: ${p => p.theme.pagination.borderColor};
      color: ${p => p.theme.pagination.color};
      background: ${p => p.theme.pagination.bg};
    }

    .ant-pagination-item a {
      color: ${p => p.theme.pagination.color};
    }

    .ant-pagination-item-active,
    .ant-pagination-item-active:focus {
      border-color: ${p => p.theme.pagination.active.borderColor};
      background: ${p => p.theme.pagination.active.bg};

      a {
        color: ${p => p.theme.pagination.active.color};
      }
    }

    .ant-table-pagination.ant-pagination {
      margin-top: 32px;
    }

    .ant-pagination-item:hover,
    .ant-pagination-prev:hover .ant-pagination-item-link,
    .ant-pagination-next:hover .ant-pagination-item-link {
      border-color: ${p => p.theme.pagination.hover.borderColor};
      background: ${p => p.theme.pagination.hover.bg};
      color: ${p => p.theme.pagination.hover.color};
      a {
        color: ${p => p.theme.pagination.hover.color};
      }
    }

    .ant-pagination-simple-pager {
      color: ${p => p.theme.pagination.color};
    }
  }

  .ant-table-thead {
    line-height: 1em;

    > tr > th {
      font-size: 13px;
      font-weight: normal;
      color: ${p =>
        p.simpleMode
          ? p.theme.table.head.simpleModeColor
          : p.theme.table.head.color};
      background: ${p => p.theme.table.head.bg};
      border-color: transparent transparent
        ${p =>
          p.simpleMode
            ? p.theme.table.head.simpleModeSeparatorColor
            : p.theme.table.head.separatorColor};
    }
  }

  .ant-table-tbody {
    > tr {
      > td {
        height: 48px;
        padding-top: 7px;
        padding-bottom: 7px;
        line-height: 1em;
        background: ${p => p.theme.table.cell.oddBg};
        color: ${p => p.theme.table.cell.color};
        border-top: 1px solid transparent;
        border-bottom: ${p => p.theme.table.cell.border};
        border-right: ${p =>
          p.simpleMode ? p.theme.table.cell.border : 'none'};
      }
      &:nth-child(even) {
        > td {
          background: ${p => p.theme.table.cell.evenBg};
        }
      }
    }
  }

  .ant-table-tbody
    > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(
      .ant-table-row-selected
    )
    > td {
    background: ${p => p.theme.table.cell.bgHover} !important;
  }

  .ant-table-tbody
    > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
    > td {
    background: ${p => p.theme.table.cell.bgHover} !important;
  }

  .ant-table-tbody > tr.ant-table-row-selected td {
    background: ${p => p.theme.table.cell.selectedBg};
  }

  .ant-checkbox-inner,
  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    background-color: ${p => p.theme.checkbox.bg};
    border-color: ${p => p.theme.checkbox.border};
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${p => p.theme.checkbox.checkedBg};
    border-color: ${p => p.theme.checkbox.checkedBorderColor};
  }

  .ant-checkbox-checked .ant-checkbox-inner::after {
    border: 2px solid ${p => p.theme.checkbox.checkedColor};
    border-top: 0;
    border-left: 0;
  }

  .ant-checkbox-indeterminate .ant-checkbox-inner {
    border-color: ${p => p.theme.checkbox.checkedBorderColor};
    ::after {
      background-color: ${p => p.theme.checkbox.checkedColor};
      height: 2px;
    }
  }

  .editable-cell {
    position: relative;
  }

  .editable-cell-value-wrap {
    padding: 0 12px;
    cursor: pointer;
  }

  .editable-row:hover .editable-cell-value-wrap {
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    padding: 4px 11px;
  }

  .ant-form-explain {
    font-size: 13px;
  }

  .has-error .ant-form-explain {
    position: absolute !important;
    font-size: 12px !important;
  }
`

class TableComponent<T extends any> extends React.Component<
  TableProps<T> & {
    simpleMode?: boolean
  }
> {
  static Column = Table.Column
  render() {
    return <StyledTable {...this.props}>{this.props.children}</StyledTable>
  }
}

export default TableComponent
